export function invalidBodyError(body: any): TypeError {
  return new TypeError(`Invalid response body: ${JSON.stringify(body)}`)
}
